import { FormFieldTypes } from "../../../../data/formFieldType";

export const MembershipSubscriptionData = {
  name: "membershipSubscription",
  initialState: {
    subscriptionType: null,
    billingCategory: null,
    applicationType: null,
    linkedMember: null,
    applicationTerm: null,
    subscriptionStartDate: null,
    subscriptionEndDate: null
  },
  formFields: [
    {
      id: "subscriptionType",
      lable: "Subscription Type",
      Field_Name: "Subscription Type",
      fieldType: FormFieldTypes.SELECT,
      dataField: "subscriptionType",
      fieldSetting: {
        placeholder: "Select",
        options: [],
        isDisable:true
      },
      style: {
        containerCss: "col-lg-6 col-xl-6 col-md-6 col-sm-12 col-12 mb-2 mb-3",
      },
    },
    {
      id: "billingCategory",
      lable: "Billing Category",
      Field_Name: "Billing Category",
      fieldType: FormFieldTypes.SELECT,
      dataField: "billingCategory",
      fieldSetting: {
        placeholder: "Select",
        options: [],
        isDisable:true
      },
      style: {
        containerCss: "col-lg-6 col-xl-6 col-md-6 col-sm-12 col-12 mb-2 mb-3",
      },
    },
    {
      id: "applicationType",
      lable: "Application Type",
      Field_Name: "Application Type",
      fieldType: FormFieldTypes.SELECT,
      dataField: "applicationType",
      fieldSetting: {
        placeholder: "Select",
        options: [],
        isDisable:true
      },
      style: {
        containerCss: "col-lg-6 col-xl-6 col-md-6 col-sm-12 col-12 mb-2 mb-3",
      },
    },
    {
      id: "linkedMember",
      lable: "Linked Member",
      Field_Name: "Linked Member",
      fieldType: FormFieldTypes.SELECT,
      dataField: "linkedMember",
      fieldSetting: {
        placeholder: "Select",
        options: [],
        isDisable:true
      },
      style: {
        containerCss: "col-lg-6 col-xl-6 col-md-6 col-sm-12 col-12 mb-2 mb-3",
      },
    },
    {
      id: "applicationTerm",
      lable: "Application Term",
      Field_Name: "Application Term",
      fieldType: FormFieldTypes.SELECT,
      dataField: "applicationTerm",
      fieldSetting: {
        placeholder: "Select",
        options: [],
        isDisable:true
      },
      style: {
        containerCss: "col-lg-6 col-xl-6 col-md-6 col-sm-12 col-12 mb-2 mb-3",
      },
    },
    {
      id: "",
      lable: "",
      Field_Name: "",
      fieldType: FormFieldTypes.MAINFORMTITLE,
      dataField: "",
      fieldSetting: {
        placeholder: "Select",
        options: [],
        isDisable:true
      },
      style: {
        containerCss: "col-lg-6 col-xl-6 col-md-6 col-sm-12 col-12 mb-2 mb-3",
      },
    },
    {
      id: "subscriptionStartDate",
      lable: "Subscription Start Date",
      Field_Name: "Subscription Start Date",
      fieldType: FormFieldTypes.DATEPICKER,
      dataField: "subscriptionStartDate",
      fieldSetting: {
        placeholder: "Select",
        // allowSpace: true,
        isDisable:true
      },
      style: {
        containerCss: "col-lg-6 col-xl-6 col-md-6 col-sm-12 col-12 mb-2",
      },
    },
    {
      id: "subscriptionEndDate",
      lable: "Subscription End Date",
      Field_Name: "Subscription End Date",
      fieldType: FormFieldTypes.DATEPICKER,
      dataField: "subscriptionEndDate",
      fieldSetting: {
        placeholder: "Select",
        // allowSpace: true,
        isDisable:true
      },
      style: {
        containerCss: "col-lg-6 col-xl-6 col-md-6 col-sm-12 col-12 mb-2",
      },
    },
  ],
  formSetting: {
    isViewOnly: false,
  },
};